import { render, staticRenderFns } from "./report-drill.vue?vue&type=template&id=2b08043c&scoped=true"
import script from "./report-drill.vue?vue&type=script&setup=true&lang=js"
export * from "./report-drill.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b08043c",
  null
  
)

export default component.exports